@if (iconName === 'progress') {
  <div class="loading">
    <pp-spinner class="spinner"></pp-spinner>
  </div>
} @else if (iconName) {
  <pp-status-icon [iconName]="iconName" [status]="status()" [size]="iconSize()">
  </pp-status-icon>
}

<ng-content select="[beforeTitle]"></ng-content>

<h4 class="title">
  {{ title() }}
</h4>

<ng-content select="[afterTitle]"></ng-content>

@if (closeCaption) {
  <div class="pp-form-actions">
    <button
      type="button"
      puButton
      size="m"
      uiType="secondary"
      (click)="discard.emit()">
      {{ closeCaption }}
    </button>
  </div>
}
